module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productSlider"
  }, [_c('div', {
    staticClass: "sliderWrapper"
  }, [_c('div', {
    staticClass: "container1"
  }, [_c('section', {
    staticClass: "vertical-slider"
  }, [_vm._l((_vm.items), function(item) {
    return [(item.video) ? [(item.smallImg) ? _c('div', {
      staticClass: "itm video"
    }, [_c('img', {
      attrs: {
        "src": item.smallImg,
        "alt": item.alt
      }
    })]) : _vm._e()] : [(item.smallImg) ? _c('div', {
      staticClass: "itm"
    }, [_c('img', {
      attrs: {
        "src": item.smallImg,
        "alt": item.alt
      }
    })]) : _vm._e()]]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "container2"
  }, [_c('section', {
    staticClass: "main-photo"
  }, [_vm._l((_vm.items), function(item) {
    return [(item.video) ? [_c('div', {
      staticClass: "item"
    }, [_c('iframe', {
      attrs: {
        "src": item.video,
        "frameborder": "0"
      }
    })])] : [(item.img) ? _c('a', {
      staticClass: "item",
      attrs: {
        "href": item.img,
        "data-fancybox": "group"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.alt
      }
    })]) : _vm._e()]]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d0e03f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/slickSlider.vue
// module id = 285
// module chunks = 38